"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COP = exports.SGD = exports.JPY = exports.AUD = exports.GBP = exports.EUR = exports.USD = void 0;
var USD = 'USD';
exports.USD = USD;
var EUR = 'EUR';
exports.EUR = EUR;
var GBP = 'GBP';
exports.GBP = GBP;
var AUD = 'AUD';
exports.AUD = AUD;
var JPY = 'JPY';
exports.JPY = JPY;
var SGD = 'SGD';
exports.SGD = SGD;
var COP = 'COP';
exports.COP = COP;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/constants/CurrencyCodes.js
// module id = 115
// module chunks = 5 6 7